// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OWmC","rootNoMargin":"styles_rootNoMargin__3jKi8"};